/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const HealthResponse = zod.object({
  status: zod.enum(['ok']),
  service: zod.enum(['echo-api']),
  time: zod.iso.datetime({ offset: true }),
});

export type HealthResponse = zod.input<typeof HealthResponse>;
export type HealthResponseOutput = zod.output<typeof HealthResponse>;
